export default __webpack_public_path__ + "static/tech-stack-9a1694450af4da511af76c79ec3cabdf.png";